import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import router from './router'
import VueLocalForage from 'vue-localforage'
import VueJWT from 'vuejs-jwt'
import moment from 'moment'
import "../node_modules/ag-grid/dist/styles/ag-grid.css";
import "../node_modules/ag-grid/dist/styles/ag-theme-material.css";
import * as VueGoogleMaps from 'vue2-google-maps'
import SailsPlugin from './plugins/sails'

Vue.use(VueJWT)
Vue.use(SailsPlugin)
Vue.use(Vuetify, { theme: {
  primary: "#3F51B5",
  secondary: "#0288D1",
  accent: "#9C27B0",
  error: "#f44336",
  warning: "#F57C00",
  info: "#2196F3",
  success: "#4caf50"
}})
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDlTrvBx2i7UDEa4VNcja_2UDMh5vgEJ_0',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }})
Vue.config.productionTip = false
Vue.use(VueLocalForage)

/*new Vue({
  router,
  render: h => h(App)
}).$mount('#app')*/

Vue.filter('date', function (value) {
  if (!value) return ''
  return moment(value).format('YYYY-MM-DD HH:mm:ss')
})

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js